<template>
  <div>
    <b-row>
      <b-col>
        <b-form-group label-for="concept_product_name_eng" label-cols-sm="5"
        class="nameHeightConcept" :style="checkNameEng ? 'color:red' : 'color:black'">
          <template v-slot:label>
            ชื่อผลิตภัณฑ์ภาษาอังกฤษ <span class="text-danger">*</span>
          </template>
          <b-input-group>
            <b-form-input type="text" name="concept_product_name_eng"
            :value="conceptProductDetail.name_eng"
            @change="updateData({name_eng: $event})">
            </b-form-input>
          </b-input-group>
        </b-form-group>

        <b-form-group label="แนวคิดจากชุมชนภาษาอังกฤษ" label-for="concept_eng"
        label-cols-sm="5">
          <quill-editor v-model="concept_eng" :options="editorOption" class="editorHeight"
          @change="updateData({concept_eng:
          `<div class=&quot;ql-editor&quot;>${$event.html}</div>`})"></quill-editor>
        </b-form-group>
        <br><br><br>

        <b-form-group label="ผู้ติดต่อประสานงานภาษาอังกฤษ" label-for="contact_eng"
        label-cols-sm="5">
          <quill-editor v-model="contact_eng" :options="editorOption" class="editorHeight"
          @change="updateData({contact_eng:
          `<div class=&quot;ql-editor&quot;>${$event.html}</div>`})"></quill-editor>
        </b-form-group>
        <br><br><br>

        <b-form-group label="แนวความคิดภาษาอังกฤษ" label-for="detail_concept_eng"
        label-cols-sm="5">
          <quill-editor v-model="detail_concept_eng" :options="editorOption" class="editorHeight"
          @change="updateData({detail_concept_eng:
          `<div class=&quot;ql-editor&quot;>${$event.html}</div>`})"></quill-editor>
        </b-form-group>
        <br><br><br>

        <b-form-group label="การออกแบบภาษาอังกฤษ" label-for="detail_design_eng"
        label-cols-sm="5">
          <quill-editor v-model="detail_design_eng" :options="editorOption" class="editorHeight"
          @change="updateData({detail_design_eng:
          `<div class=&quot;ql-editor&quot;>${$event.html}</div>`})"></quill-editor>
        </b-form-group>
        <br><br><br>

         <b-form-group label="วัสดุภาษาอังกฤษ" label-for="detail_material_eng"
         label-cols-sm="5">
          <quill-editor v-model="detail_material_eng" :options="editorOption" class="editorHeight"
          @change="updateData({detail_material_eng:
          `<div class=&quot;ql-editor&quot;>${$event.html}</div>`})"></quill-editor>
        </b-form-group>
        <br><br><br>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('ConceptProduct', ['conceptProductDetail', 'editorOption', 'checkNameEng']),
    ConceptProductData() {
      return this.conceptProductDetail;
    },
  },
  watch: {
    ConceptProductData() {
      this.concept_eng = this.conceptProductDetail.concept_eng;
      this.contact_eng = this.conceptProductDetail.contact_eng;
      this.detail_concept_eng = this.conceptProductDetail.detail_concept_eng;
      this.detail_design_eng = this.conceptProductDetail.detail_design_eng;
      this.detail_material_eng = this.conceptProductDetail.detail_material_eng;
    },
  },
  data() {
    return {
      concept_eng: '',
      contact_eng: '',
      detail_concept_eng: '',
      detail_design_eng: '',
      detail_material_eng: '',
    };
  },
  methods: {
    ...mapActions('ConceptProduct', ['updateField']),
    updateData(data) {
      console.log('updateData', data);
      this.updateField(data);
      console.log('updatedConceptProductDetail', this.conceptProductDetail);
    },
  },
};
</script>

<style>
  .titleDetailConcpetProduct {
    font-size: 20px;
    color: #173B6B;
  }
  .editorHeight {
    height: 200px;
  }
  .nameHeightConcept {
    height: 60px;
  }
</style>
